import { useState } from 'react';
import { PositionList } from '../../helpers/apiService';
import { Item } from './../item/item';
import styles from './style.module.scss';
import { Headline } from '../headline/headline';
import { Copy } from '../copy/copy';
import { IconWithLabel } from '../iconWithLabel/iconWithLabel';
import { Button } from '../button/button';
import { isDesktop } from '../../helpers/viewports';

interface IProps {
	searchResultsFiltered: PositionList | null;
	itemCount: number;
	setItemCount: (newCount: number) => void;
	resetFilters: () => void;
}

export function List({ searchResultsFiltered, itemCount, setItemCount, resetFilters }: IProps) {
	const { labels } = window;

	return (
		<div>
			<div className={styles.searchResultInfo}>
				<Headline tag="h4" className={styles.headline}>
					{/* TODO: Change Label */}
					{`${searchResultsFiltered?.SearchResult.SearchResultCountAll} ${labels['headline']}`}
				</Headline>
				<Copy text={labels['text']} />
			</div>
			{searchResultsFiltered?.SearchResult.SearchResultItems.map((item, index) =>
				index < itemCount ? <Item key={index} item={item} /> : null
			)}
			{searchResultsFiltered && itemCount < searchResultsFiltered?.SearchResult.SearchResultCountAll && (
				<Button
					className={styles.loadMoreButton}
					withIcon
					isSecondary
					fullwidth={!isDesktop()}
					onClick={() => setItemCount(itemCount + 10)}
				>
					<IconWithLabel tag={'p'} className={`${styles.buttonWithIcon} ${styles.refreshIcon}`}>
						{labels['loadMoreButton']}
					</IconWithLabel>
				</Button>
			)}
			{searchResultsFiltered && searchResultsFiltered?.SearchResult.SearchResultCountAll <= 0 && (
				<Button
					className={styles.loadMoreButton}
					withIcon
					isSecondary
					fullwidth={!isDesktop()}
					onClick={resetFilters}
				>
					<IconWithLabel tag={'p'} className={`${styles.buttonWithIcon} ${styles.refreshIcon}`}>
						{labels['filter.resetFilters']}
					</IconWithLabel>
				</Button>
			)}
		</div>
	);
}
